import Vue from 'vue';
import ProductsBasic from '@/plugins/graphql/queries/v2/inquiry/products-basic.gql';
import { InquiryProductBasicModel } from '@/helpers/entities/models/InquiryProductBasicModel';
import { omitBy, isNull } from 'lodash';
export default Vue.extend({
    apollo: {
        products: {
            query: ProductsBasic,
            fetchPolicy: 'cache-and-network',
            variables() {
                const vars = {
                    appUuid: this.appUuid,
                    first: this.limit,
                    keyword: this.keyword,
                };
                return omitBy(vars, isNull);
            },
            update(data) {
                const nodes = data.fetchInquiryProductsByApp.edges;
                return nodes.map((productNode) => {
                    return new InquiryProductBasicModel(productNode.node);
                });
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        limit: {
            type: Number,
            default: 5,
        },
        keyword: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            products: null,
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                products: this.products,
            });
        }
    },
});
